import { useClassId } from "hooks";
import { FC } from "types";
import { QuickGameList } from "./QuickGameList";

export const QuickGameListContainer: FC = () => {
  useClassId(true);

  return <QuickGameList />;
};
